const DEVICE_ACCESS_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
};

export { DEVICE_ACCESS_STATUS };

export const NETWORK_PING_URL = "https://1.1.1.1/cdn-cgi/trace";

export const NETWORK_PING_INTERVAL = 3000;
export const NETWORK_PING_TIMEOUT = 2000;
export const NETWORK_FAIL_LIMIT = 3;
export const NETWORK_STATUS_CONFIRMATION_COUNT = 3;
export const NETWORK_THRESHOLDS = {
  WEAK: 500,
  POOR: 1200,
};

export const NETWORK_UI_CONFIG = {
  weak: {
    title: "Slow Network",
    message: "Your network is slow. You may experience reduced quality.",
    border: "#FDD835",
    bg: "rgba(255, 249, 196, 0.92)",
    text: "#5D5100",
    icon: "⚠️",
  },
  poor: {
    title: "Unstable Network",
    message: "Your connection is unstable.",
    border: "#FB8C00",
    bg: "rgba(255, 236, 179, 0.92)",
    text: "#5C3100",
    icon: "📶",
  },
  disconnected: {
    title: "You Are Offline",
    message: "Check your internet connection.",
    border: "#E53935",
    bg: "rgba(255, 205, 210, 0.92)",
    text: "#7F0000",
    icon: "📡",
  },
  online: {
    title: "Back Online",
    message: "Your connection has been restored.",
    border: "#43A047",
    bg: "rgba(200, 230, 201, 0.95)",
    text: "#1B5E20",
    icon: "✅",
  },
};
